

































import { Component } from 'vue-property-decorator'
import BaseDialog from '@/utils/dialog-control'
import $Api from '@api'
import { translate } from '@/utils/filters'
import FormValidator from '@/utils/form-validator'

@Component
export default class MerchantDialog extends BaseDialog {
    formValidator = new FormValidator()
    form = {
        channelName: '',
        channelNo: '',
        status: '',
        id: ''
    }

    rules = {
        channelName: [
            { required: true, message: translate('common.noEmpty'), trigger: 'change' },
            { validator: this.formValidator.maxLength(20), trigger: 'change' }
        ],
        channelNo: [
            { required: true, message: translate('common.noEmpty'), trigger: 'change' },
            { validator: this.formValidator.maxLength(100), trigger: 'change' },
            { validator: this.formValidator.number(), trigger: 'change' }
        ],
        id: [
            { required: true, message: translate('common.noEmpty'), trigger: 'change' },
            { validator: this.formValidator.maxLength(20), trigger: 'change' },
            { validator: this.formValidator.number(), trigger: 'change' }
        ],
        status: { required: true, message: translate('common.default.option'), trigger: 'change' }
    }

    create() {
        return $Api.channelService.addChannel(this.form)
    }

    update() {
        return $Api.channelService.editChannel(this.form)
    }

    onOpen() {
    }

    onClose() {

    }
}
